module.exports = __webpack_public_path__ + "static/media/minsize-default.402f66da.svg";